/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        /* Find Closest */
        $.fn.findClosest = function(selector) {
          return this.is(selector) ? this.filter(selector).first() : this.find(selector).first();
        };

        /* Variables */
        var htmlBody = $('html, body');

        /* Disable Scrolling */
        function disableScrolling() {
          if($('body').css('position') != 'fixed') {
            $('body').css('top', '-' + $(window).scrollTop() + 'px').css('position', 'fixed').css('width', '100%');
          }
        }
        function enableScrolling() {
          if($('body').css('position') == 'fixed') {
            var scrollTop = parseInt($('body').css('top').replace('-', '').replace('px', ''));
            $('body').css('top', '0').css('position', 'static').css('width', 'auto');
            $(window).scrollTop(scrollTop);
          }
        }

        /* Main Menu Overlay */
        function mainMenuOverlay() {
          var mainMenu = $('.main-menu');
          var parentItem = mainMenu.find('.parent-item');
          var mainMenuOverlay = $('.main-menu-overlay');
          var submenu = mainMenuOverlay.find('.submenu');
          $('.open-products-menu').click(function() {
            parentItem.filter('[data-id="products"]').addClass('active');
            mainMenuOverlay.show();
            submenu.filter('[data-id="products"]').show();
          });
          parentItem.on({
            mouseenter: function () {
              parentItem.removeClass('active');
              $(this).addClass('active');
              var id = $(this).attr('data-id');
              submenu.hide();
              if(submenu.filter('[data-id="' +  id+ '"]').length > 0) {
                mainMenuOverlay.show();
                submenu.filter('[data-id="' +  id+ '"]').show();
              } else {
                mainMenuOverlay.hide();
              }
            }
          });
          mainMenu.on({
            mouseleave: function () {
              mainMenuOverlay.hide();
              parentItem.removeClass('active');
              submenu.hide();
            }
          });
        }
        mainMenuOverlay();

        /* Product Filter */
        var productList = $('.list-wrapper.products .list');
        var productFilter = $('.product-filter');
        var productFilterButton = productFilter.find('a');
        function updateProductsList() {
          productList.isotope({
            filter: '[data-category~="' + productFilter.find('a.selected').attr('data-category') + '"]'
          });

          if(!productList.data('isotope').filteredItems.length) {
            productList.isotope({
              filter: '.no-hits'
            });
          }

          setCategoryTeaserProductHeight();
        }
        function updateProductsSlider() {
          var productSlider = $('.product-slider');
          productSlider.removeClass('active');
          productSlider.findClosest('[data-category~="' + productFilter.find('a.selected').attr('data-category') + '"]').addClass('active');
        }
        productFilterButton.click(function() {
          productFilterButton.removeClass('selected');
          $(this).addClass('selected');
          if(productList.length > 0) {
            updateProductsList();
          } else {
            updateProductsSlider();
          }
        });
        if(productFilterButton.length > 0) {
          productList.isotope({
            filter: '[data-category~="' + productFilter.find('a.selected').attr('data-category') + '"]',
            layoutMode: 'fitRows',
            transitionDuration: 500,
            hiddenStyle: {
              opacity: 0
            },
            visibleStyle: {
              opacity: 1
            }
          });
        }

        /* Downloads */
        function isEmpty( el ){
          return !$.trim(el.html())
        }

        var downloadsList = $('.downloads-list');
        var downloadsListBody = $('.downloads-list .table .tbody');
        function updateDownloadsTable() {
          if(downloadSelection01Select[0].selectedIndex != 0 && downloadSelection02Select[0].selectedIndex != 0) {
            if(downloadsList.hasClass('show')) {
              var transitionDuration = 500;
            } else {
              var transitionDuration = 0;
              downloadsList.addClass('show');
            }

            var selection01 = downloadSelection01Select[0].options[downloadSelection01Select[0].selectedIndex].value;
            var selection02 = downloadSelection02Select[0].options[downloadSelection02Select[0].selectedIndex].value;
            var orderBy = orderBySelect[0].options[orderBySelect[0].selectedIndex].value;
            var sortAscending = true;
            if(orderBy == 'drive-gas') {
              orderBy = 'drive';
              sortAscending = {
                drive: false,
                model: true
              };
              $('.cell-drive').each(function() {
                if($(this).parent().find('.cell-drive:contains("zzz")').length > 0) {
                  $(this).empty();
                }
              });
            } else if(orderBy == 'drive-electric') {
              orderBy = 'drive';
              $('.cell-drive').each(function() {
                if(isEmpty($(this))) {
                  $(this).html('zzz');
                }
              });
            }
            downloadsListBody.isotope('updateSortData').isotope();
            downloadsListBody.isotope({
              filter: '[data-selection-01="' + selection01 + '"][data-selection-02~="' + selection02 + '"]',
              sortBy: orderBy,
              sortAscending: sortAscending,
              transitionDuration: transitionDuration
            });

            if(!downloadsListBody.data('isotope').filteredItems.length) {
              downloadsListBody.isotope({
                filter: '.no-hits',
                transitionDuration: transitionDuration
              });
            }
          } else {
            downloadsList.removeClass('show');
          }
        }
        downloadsListBody.isotope({
          layoutMode: 'vertical',
          getSortData: {
            default: '.cell-model',
            model: '.cell-model',
            language: '.cell-lanugage',
            drive: '.cell-drive'
          },
          sortBy: ['default', 'language'],
          hiddenStyle: {
            opacity: 0
          },
          visibleStyle: {
            opacity: 1
          }
        });

        /* Events */
        var eventsList = $('.events-list');
        var eventsListBody = $('.events-list .table .tbody');
        function updateEventsTable() {
          if(eventCategorySelect[0].selectedIndex != 0) {
            var eventCategory = eventCategorySelect[0].options[eventCategorySelect[0].selectedIndex].value;
            eventsListBody.isotope({
              filter: '[data-category="' + eventCategory + '"]',
            });

            if(!eventsListBody.data('isotope').filteredItems.length) {
              eventsListBody.isotope({
                filter: '.no-hits',
              });
            }
          } else {
            eventsListBody.isotope({
              filter: ':not(.no-hits)'
            });
          }
        }
        $(window).load(function() {
          eventsListBody.isotope({
            layoutMode: 'vertical',
            filter: ':not(.no-hits)',
            transitionDuration: 500,
            hiddenStyle: {
              opacity: 0
            },
            visibleStyle: {
              opacity: 1
            }
          });
        });
        var registerForEvent = $('.register-for-event');
        registerForEvent.click(function(e) {
          e.preventDefault();
          Cookies.set('event', $(this).attr('data-event'), { expires: 1 });
          window.location.href = registerForEvent.attr('href');
        });
        var eventRegistrationForm = $('.registration');
        function updateEventRegistrationForm() {
          eventRegistrationForm.hide();
          if(eventRegistrationSelect.length > 0 && eventRegistrationSelect[0].selectedIndex != 0) {
            var eventForm = eventRegistrationSelect[0].options[eventRegistrationSelect[0].selectedIndex].getAttribute('data-form');
            var eventName = eventRegistrationSelect[0].options[eventRegistrationSelect[0].selectedIndex].text;
            eventRegistrationForm.parent().find('[data-form="' + eventForm + '"]').show().find('nf-field:first-child .ninja-forms-field').val(eventName);
          }
        }

        /* Select */
        var languageSwitcherSelect = $('.language-switcher select');
        languageSwitcherSelect.select2({
          dropdownCssClass: 'language-switcher-dropdown',
          minimumResultsForSearch: Infinity
        });
        languageSwitcherSelect.on('change', function() {
          window.location.href = this.value;
        });
        var contentSelect = $('.content select, .overlay select');
        contentSelect.select2({
          containerCssClass: 'normal-dropdown not-selected',
          dropdownCssClass: 'normal-dropdown',
          minimumResultsForSearch: Infinity
        });
        contentSelect.on('change', function() {
          if($(this)[0].selectedIndex == 0) {
            $(this).next().find('.select2-selection').addClass('not-selected');
          } else {
            $(this).next().find('.select2-selection').removeClass('not-selected');
          }
        });
        var contentSelectDark = $('.content select.dark, .overlay select.dark');
        contentSelectDark.select2({
          containerCssClass: 'normal-dropdown not-selected dark',
          dropdownCssClass: 'normal-dropdown dark',
          minimumResultsForSearch: Infinity
        });
        contentSelectDark.on('change', function() {
          if($(this)[0].selectedIndex == 0) {
            $(this).next().find('.select2-selection').addClass('not-selected');
          } else {
            $(this).next().find('.select2-selection').removeClass('not-selected');
          }
        });
        var downloadSelection01Select = $('.downloads-filter .selection-01-wrapper select');
        var downloadSelection02Wrapper = $('.downloads-filter .selection-02-wrapper');
        var downloadSelection02Select = $('.downloads-filter .selection-02-wrapper select');
        var orderByWrapper = $('.downloads-filter .order-by-wrapper');
        var orderBySelect = $('.downloads-filter .order-by-wrapper select');
        downloadSelection01Select.on('change', function() {
          if($(this)[0].selectedIndex == 0) {
            downloadSelection02Wrapper.addClass('disabled');
            orderByWrapper.addClass('disabled');
          } else {
            downloadSelection02Wrapper.removeClass('disabled');
            if(downloadSelection02Select[0].selectedIndex != 0) {
              orderByWrapper.removeClass('disabled');
            }
          }
          updateDownloadsTable();
        });
        downloadSelection02Select.on('change', function() {
          if($(this)[0].selectedIndex == 0) {
            orderByWrapper.addClass('disabled');
          } else {
            orderByWrapper.removeClass('disabled');
          }
          updateDownloadsTable();
        });
        orderByWrapper.on('change', function() {
          updateDownloadsTable();
        });
        var eventCategorySelect = $('.events-filter select');
        eventCategorySelect.on('change', function() {
          updateEventsTable();
        });
        var eventRegistrationSelect = $('.event-select select');
        eventRegistrationSelect.on('change', function() {
          updateEventRegistrationForm();

        });
        if(Cookies.get('event') != undefined) {
          eventId = Cookies.get('event');
          eventRegistrationSelect.val(eventId);
          eventRegistrationSelect.trigger('change');
        }

        /* Forms */
        var saveprintButtonParameters = '';
        jQuery(document).on('nfFormReady', function(e, layoutView) {
          updateEventRegistrationForm();

          var nfField = $('nf-field');
          nfField.each(function() {
            if($(this).find('.nf-field-container').hasClass('clear')) {
              $(this).addClass('clear');
            }
            if($(this).find('.nf-field-container').hasClass('wide')) {
              $(this).addClass('wide');
            }
            if($(this).find('.nf-field-container').hasClass('semi-wide')) {
              $(this).addClass('semi-wide');
            }
            if($(this).find('.nf-field-container').hasClass('spacing-top')) {
              $(this).addClass('spacing-top');
            }
            if($(this).find('.nf-field-container').hasClass('small')) {
              $(this).addClass('small');
            }
            if($(this).find('.nf-field-container').hasClass('semi-small')) {
              $(this).addClass('semi-small');
            }
            if($(this).find('.nf-field-container').hasClass('right')) {
              $(this).addClass('right');
            }
          });

          var ninjaFormsSelect = $('.nf-form-cont select');
          var ninjaFormsCountrySelect = $('.nf-form-cont .nf-field-container.listcountry-container select');

          /*var ninjaFormsCountrySelectOption = ninjaFormsCountrySelect.find('option');
          function sort(a, b) {
            a = a.text.toLowerCase();
            b = b.text.toLowerCase();
            if(a > b) {
              return 1;
            } else if(a < b) {
              return -1;
            }
            return 0;
          }
          ninjaFormsCountrySelectOption.sort(sort);
          ninjaFormsCountrySelect.html(ninjaFormsCountrySelectOption);*/

          ninjaFormsSelect.select2({
            containerCssClass: 'normal-dropdown not-selected',
            dropdownCssClass: 'normal-dropdown form-dropdown',
            minimumResultsForSearch: Infinity
          });
          var ninjaFormsCountrySelect = $('.nf-form-cont .nf-field-container.listcountry-container select');
          ninjaFormsCountrySelect.select2({
            containerCssClass: 'normal-dropdown',
            dropdownCssClass: 'normal-dropdown form-dropdown',
            minimumResultsForSearch: Infinity
          });
          ninjaFormsSelect.on('change', function() {
            if($(this)[0].selectedIndex == 0) {
              $(this).next().find('.select2-selection').addClass('not-selected');
            } else {
              $(this).next().find('.select2-selection').removeClass('not-selected');
            }
          });

          if($('html').attr('lang') == 'de-DE') {
            $('.nf-form-cont .nf-field-container.installation-at input.datepicker').attr('placeholder', 'Installation am (Datum) *');
          } else {
            $('.nf-form-cont .nf-field-container.installation-at input.datepicker').attr('placeholder', 'Installation on (date) *');
          }

          function addPrintButtonParameters(printButtonParameters) {
            document.createElement('nf-field');
            var nfFieldsWrap = $('.nf-form-cont .nf-form-content nf-fields-wrap');
            printButtonParameters += '&serial=' + encodeURIComponent(nfFieldsWrap.find('nf-field:nth-child(2) .nf-field-element input').val());
            printButtonParameters += '&product=' + encodeURIComponent(nfFieldsWrap.find('nf-field:nth-child(3) .nf-field-element input').val());
            printButtonParameters += '&item=' + encodeURIComponent(nfFieldsWrap.find('nf-field:nth-child(4) .nf-field-element input').val());
            printButtonParameters += '&io=' + encodeURIComponent(nfFieldsWrap.find('nf-field:nth-child(5) .nf-field-element input').val());
            printButtonParameters += '&ib=' + encodeURIComponent(nfFieldsWrap.find('nf-field:nth-child(6) .nf-field-element input').val());
            printButtonParameters += '&company=' + encodeURIComponent(nfFieldsWrap.find('nf-field:nth-child(8) .nf-field-element input').val());
            printButtonParameters += '&full_name=' + encodeURIComponent(nfFieldsWrap.find('nf-field:nth-child(9) .nf-field-element input').val());
            printButtonParameters += '&type=' + encodeURIComponent(nfFieldsWrap.find('nf-field:nth-child(10) .nf-field-element input').val());
            printButtonParameters += '&position=' + encodeURIComponent(nfFieldsWrap.find('nf-field:nth-child(11) .nf-field-element input').val());
            printButtonParameters += '&street=' + encodeURIComponent(nfFieldsWrap.find('nf-field:nth-child(12) .nf-field-element input').val());
            printButtonParameters += '&zip=' + encodeURIComponent(nfFieldsWrap.find('nf-field:nth-child(13) .nf-field-element input').val());
            printButtonParameters += '&city=' + encodeURIComponent(nfFieldsWrap.find('nf-field:nth-child(14) .nf-field-element input').val());
            printButtonParameters += '&country=' + encodeURIComponent(nfFieldsWrap.find('nf-field:nth-child(15) .nf-field-element select option:selected').text());
            printButtonParameters += '&state=' + encodeURIComponent(nfFieldsWrap.find('nf-field:nth-child(16) .nf-field-element input').val());
            printButtonParameters += '&phone=' + encodeURIComponent(nfFieldsWrap.find('nf-field:nth-child(17) .nf-field-element input').val());
            printButtonParameters += '&email=' + encodeURIComponent(nfFieldsWrap.find('nf-field:nth-child(18) .nf-field-element input').val());
            return printButtonParameters;
          }

          if($('body').hasClass('page-id-279') || $('body').hasClass('page-id-917') || $('body').hasClass('page-id-1945')) {
            var printString = 'Print';
            if($('body').hasClass('page-id-279')) {
              printString = 'Drucken';
            }
            var printButton = '<div class="print-button-wrapper"><a class="print-button" target="_blank">' + printString + '</a></div>';
            $('.nf-field-container.submit-container').append(printButton);
            $('.nf-field-container.submit-container').on('mousedown', '.nf-field-element input', function() {
              var printButtonParameters = '?format=pdf';
              printButtonParameters = addPrintButtonParameters(printButtonParameters);
              saveprintButtonParameters = printButtonParameters;
            });
            $('.nf-field-container.submit-container .print-button').on('click', function() {
              var printButtonParameters = '?format=pdf';
              printButtonParameters = addPrintButtonParameters(printButtonParameters);
              saveprintButtonParameters = printButtonParameters;
              var win = window.open(printButtonParameters, '_blank');
              if(win) {
                win.focus();
              }
            });
          }
        });
        jQuery( document ).on('nfFormSubmitResponse', function() {
          if($('body').hasClass('page-id-279') || $('body').hasClass('page-id-917') || $('body').hasClass('page-id-1945')) {
            var printString = 'Print';
            if($('body').hasClass('page-id-279')) {
              printString = 'Drucken';
            }
            var printButton = '<div class="print-button-wrapper"><a class="print-button" href="' + saveprintButtonParameters + '" target="_blank">' + printString + '</a></div>';
            $('.nf-response-msg').append(printButton);
          }
        });

        /* Overlay */
        var overlayCloseTriggerReload = false;
        var containerWrapper = $('.container-wrapper');
        var overlay = $('.overlay');
        var overlayBox = $('.overlay-box');
        var overlayMenu = $('.overlay-menu');
        var overlayInfo24 = $('.overlay-info-24');
        var overlayContact = $('.overlay-contact');
        var overlayDrownloadForm = $('.overlay-download-form');
        var overlayUPS = $('.overlay-ups');
        var overlayServicePartner = $('.overlay-service-partner');
        function openOverlay() {
          overlayBox.hide();
          disableScrolling();
          containerWrapper.addClass('blured');
          overlay.fadeIn(250);
          overlay.scrollTop(0);
        }
        function closeOverlay() {
          enableScrolling();
          containerWrapper.removeClass('blured');
          overlay.fadeOut(250);
        }
        var overlayClose = $('.overlay-close');
        overlayClose.click(function() {
          console.log('close', overlayCloseTriggerReload);
          if(overlayCloseTriggerReload) {
            location.reload();
          } else {
            closeOverlay();
          }
        });

        /* Menu */
        function openMenu() {
          openOverlay();
          overlayMenu.show();
        }
        var menuToggle = $('.menu-toggle');
        menuToggle.click(function() {
          openMenu();
        });

        /* Sidepanel */
        var openInfo24Button = $('.open-info-24');
        function openInfo24() {
          openOverlay();
          overlayInfo24.show();
        }
        openInfo24Button.click(function() {
          openInfo24();
        });
        var openContactButton = $('.open-contact');
        function openContact() {
          openOverlay();
          overlayContact.show();
        }
        openContactButton.click(function() {
          openContact();
        });
        function openDownloadForm(id) {
          openOverlay();
          overlayDrownloadForm.each(function() {
            $(this).find('[name^="nf-field-"]').eq(0).val(id).trigger('change');
          });
          overlayDrownloadForm.show();
        }
        $('[data-download-form]').click(function() {
          openDownloadForm($(this).attr('data-download-form'));
        });
        var openServicePartnerButton = $('.open-service-partner');
        function openServicePartner() {
          openOverlay();
          overlayServicePartner.show();
          initMap();
        }
        $('a[href*="row.ups.com"]:not(.force-open)').click(function(e) {
          e.preventDefault();
          openOverlay();
          overlayUPS.show();
        });
        openServicePartnerButton.click(function() {
          if($('[data-anchor="service-partner"]').length > 0) {
            scrollToAnchor('service-partner');
          } else {
            openServicePartner();
          }
        });

        /* Slider */
        var productSlider = $('.slider.product-slider');
        productSlider.slick({
          autoplay: false,
          appendArrows: false,
          dots: true,
          draggable: false,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          speed: 500,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
              }
            }
          ]
        });
        var inspirationalSlider = $('.slider.inspirational-slider');
        var inspirationalSliderTeaser = $('.slider.inspirational-slider').find('.teaser.case-study, .teaser.news, .teaser.recipe-big');
        inspirationalSlider.slick({
          autoplay: false,
          prevArrow: '<button type="button" class="slick-prev"></button>',
          nextArrow: '<button type="button" class="slick-next"></button>',
          dots: true,
          draggable: false,
          infinite: false,
          slidesToShow: 2,
          slidesToScroll: 2,
          speed: 500,
          variableWidth: true,
          responsive: [
            {
              breakpoint: 767,
              settings: "unslick"
            }
          ]
        });
        var teaserTextMaxHeight = 0;
        inspirationalSliderTeaser.each(function() {
          if($(this).find('.text').length > 0 && $(this).find('.text').outerHeight() > teaserTextMaxHeight) {
            teaserTextMaxHeight = $(this).find('.text').outerHeight();
          }
        });
        if(inspirationalSliderTeaser.length > 0) {
          inspirationalSliderTeaser.find('.text').css('min-height', teaserTextMaxHeight + 'px');
        }
        var teaserMaxHeight = 0;
        var teaserServicepartner = $('.slider.inspirational-slider .inspirational-item.servicepartner');
        inspirationalSliderTeaser.each(function() {
          if($(this).length > 0 && $(this).outerHeight() > teaserMaxHeight) {
            teaserMaxHeight = $(this).outerHeight();
          }
        });
        if(teaserServicepartner.length > 0) {
          teaserServicepartner.css('min-height', teaserMaxHeight + 'px');
        }
        var historySlider = $('.history-slider');
        historySlider.slick({
          autoplay: false,
          prevArrow: '<button type="button" class="slick-prev"></button><button type="button" class="slick-prev big"></button>',
          nextArrow: '<button type="button" class="slick-next"></button><button type="button" class="slick-next big"></button>',
          centerMode: true,
          dots: false,
          draggable: false,
          infinite: false,
          slidesToShow: 7,
          slidesToScroll: 1,
          speed: 750,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1
              }
            }
          ]
        });
        historySlider.find('.switch').click(function() {
          historySlider[0].slick.slickGoTo($(this).attr('data-slide'));
        });
        var blogNewsEventsSlider = $('.slider.blog-news-events-slider');
        blogNewsEventsSlider.slick({
          autoplay: false,
          prevArrow: '<button type="button" class="slick-prev"></button><button type="button" class="slick-prev big"></button>',
          nextArrow: '<button type="button" class="slick-next"></button><button type="button" class="slick-next big"></button>',
          dots: true,
          draggable: false,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          speed: 500,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
              }
            }
          ]
        });

        /* Teaser */
        var productCategoriesUlLi = $('.product-categories ul li');
        productCategoriesUlLi.hover(function() {
          var line = $(this).find('a .title .line');
          line.each(function() {
            $(this).css('width', $(this).find('span').outerWidth() + 'px');
          });
        }, function() {
          $(this).find('a .title .line').removeAttr('style');
        });
        var teaserNews = $('.list .teaser.news');
        function setTeaserNewsHeight() {
          var count = 1;
          var height = 0;
          teaserNews.each(function() {
            if($(this).find('.text').outerHeight() > height) {
              height = $(this).find('.text').outerHeight();
            }
            if(count % 3 === 0) {
              $(this).parent().find('.teaser:nth-child(' + (count - 2) + ') .text').css('height', height + 'px');
              $(this).parent().find('.teaser:nth-child(' + (count - 1) + ') .text').css('height', height + 'px');
              $(this).parent().find('.teaser:nth-child(' + count + ') .text').css('height', height + 'px');
              height = 0;
            }
            count++;
          });
        }
        setTeaserNewsHeight();
        var teaserProducts = $('.page-template-template-product-category .list .teaser.product');
        function setTeaserProductHeight() {
          var count = 1;
          var height = 0;
          teaserProducts.find('.text').css('height', 'auto');
          teaserProducts.each(function() {
            if($(this).find('.text').outerHeight() > height) {
              height = $(this).find('.text').outerHeight();
            }
            if(count % 3 === 0) {
              $(this).parent().find('.teaser:nth-child(' + (count - 2) + ') .text').css('height', height + 'px');
              $(this).parent().find('.teaser:nth-child(' + (count - 1) + ') .text').css('height', height + 'px');
              $(this).parent().find('.teaser:nth-child(' + count + ') .text').css('height', height + 'px');
              height = 0;
            }
            count++;
          });
        }
        setTeaserProductHeight();
        $(window).resize(function() {
          setTeaserProductHeight();
        });
        var listCategory = $('.list-category');
        function setCategoryTeaserProductHeight() {
          listCategory.each(function() {
            if($(this).is(':visible')) {
              var count = 1;
              var height = 0;
              $(this).find('.teaser.product .text').css('height', 'auto');
              $(this).find('.teaser.product').each(function() {
                if($(this).find('.text').outerHeight() > height) {
                  height = $(this).find('.text').outerHeight();
                }
                if(count % 3 === 0) {
                  $(this).parent().find('.teaser:nth-child(' + (count - 2) + ') .text').css('height', height + 'px');
                  $(this).parent().find('.teaser:nth-child(' + (count - 1) + ') .text').css('height', height + 'px');
                  $(this).parent().find('.teaser:nth-child(' + count + ') .text').css('height', height + 'px');
                  height = 0;
                }
                count++;
              });
            }
          });
        }
        setCategoryTeaserProductHeight();
        $(window).resize(function() {
          setCategoryTeaserProductHeight();
        });
        var productSlider = $('.product-slider');
        function setTeaserHeight() {
          productSlider.each(function() {
            var count = 1;
            var height = 0;
            $(this).find('.teaser.product .text').css('height', 'auto');
            $(this).find('.teaser.product').each(function() {
              if($(this).find('.text').outerHeight() > height) {
                height = $(this).find('.text').outerHeight();
              }
            });
            $(this).find('.teaser.product .text').css('height', height + 'px');
          });
        }
        $(window).resize(function() {
          setTeaserHeight();
        });
        var productSliderWrapper = $('.product-slider-wrapper');
        var productSlider = productSliderWrapper.find('.product-slider');
        var productSliderList = productSlider.find('.slick-list');
        function setSliderHeight() {
          var height = 0;
          productSlider.each(function() {
            $(this).css('min-height', $(this).find('.slick-list').outerHeight() + 'px');
          });
          productSliderList.each(function() {
            if($(this).outerHeight() > height) {
              height = $(this).outerHeight();
            }
          });
          productSliderWrapper.css('min-height', height + 'px');
        }
        setSliderHeight();
        $(window).resize(function() {
          setSliderHeight();
        });

        /* Accordeon */
        $('.vc_tta-panel-heading a').click(function(e) {
          setTimeout(function() {
            history.pushState("", document.title, window.location.pathname);
          }, 1);
        });

        /* Scroll to anchor */
        function scrollToAnchor(anchor) {
          if($('[data-anchor=' + anchor + ']').length > 0) {
            history.pushState('', document.title, window.location.pathname);

            var anchorElement = $('[data-anchor=' + anchor + ']');
            htmlBody.animate({ scrollTop: anchorElement.offset().top - 45 }, 500);
          }
        }

        /* Select Event Category */
        var eventCategorySelect = $('select.event-category');
        function selectEventCategory(anchor) {
          history.pushState('', document.title, window.location.pathname);

          eventCategorySelect.find('option[data-category="' + anchor + '"]').attr('selected', 'selected').trigger('change');
        }

        /* Anchor */
        var hash = window.location.hash;
        if(hash != '') {
          var anchor = window.location.hash.substring(1);
          if($('body').hasClass('page-template-template-events')) {
            selectEventCategory(anchor);
          } else {
            scrollToAnchor(anchor);
          }
        }
        $('a[href*="#"]').click(function(e) {
          var href = $(this).attr('href');
          var anchor = href.substr(href.indexOf('#') + 1);
          if($('[data-anchor=' + anchor + ']').length > 0) {
            e.preventDefault();
            closeOverlay();
            scrollToAnchor(anchor);
          }
        });

        function video() {
          var video = $('#video');
          if(video.length > 0) {
            video.find('video')[0].addEventListener('ended', function() {
              $('.video-poster').show();
            }, false);
            $('.video-poster').click(function() {
              $('.video-poster').hide();
              video.find('video')[0].play();
            });

            $('a[href$="#video"]').click(function(e) {
              e.preventDefault();
              $([document.documentElement, document.body]).animate({
                scrollTop: $('#video').offset().top - 50
              }, 509);
              $('.video-poster').hide();
              video.find('video')[0].play();
            });
          }
        }
        video();

        $('a[href$="#kontakt"], a[href$="#contact"]').click(function(e) {
          e.preventDefault();
          $('.open-contact').click();
        });

        $('a[href$="#info24"]').click(function(e) {
          e.preventDefault();
          $('.open-info-24').click();
        });

        function landingpageRowToggle() {
          var landingpageRowToggle = $('.landingpage-row-toggle');
          landingpageRowToggle.each(function() {
            $(this).next().addClass('row-toggle-box');
            $(this).find('.row-toggle').click(function() {
              $(this).toggleClass('open');
              $(this).parent().next().slideToggle(500);
              setTimeout(function() {
                window.dispatchEvent(new Event('resize'));
              }, 500);
            });
          });
        }
        landingpageRowToggle();

        function landingpageControl() {
          var landingpageControl = $('.landingpage-control');
          landingpageControl.each(function() {
            landingpageControl.find('.button').click(function() {
              landingpageControl.find('.button').removeClass('active');
              landingpageControl.find('.control-image').removeClass('active');
              $(this).addClass('active');
              landingpageControl.find('.control-image[data-id="' + $(this).attr('data-id') + '"]').addClass('active');
            });
          });
        }
        landingpageControl();

        function landingpageSlider() {
          var landingpageSlider = $('.landingpage-slider');
          landingpageSlider.each(function() {
            var slides = $(this).find('.slides');
            slides.slick({
              fade: true,
              arrows: false,
              speed: 500
            });
            $(this).find('.arrow.prev').click(function() {
              slides.slick('slickPrev');
            });
            $(this).find('.arrow.next').click(function() {
              slides.slick('slickNext');
            });
          });
        }
        landingpageSlider();

        function landingpageAnimation() {
          $('.landingpage-animation').viewportChecker({
            callbackFunction: function(elem, action) {
              elem.find('video')[0].play();
              elem.find('video')[0].addEventListener('ended', function() {
                elem.find('.refresh').addClass('show');
              }, false);
              elem.find('.refresh').click(function() {
                elem.find('video')[0].play();
                $(this).removeClass('show');
              });
            }
        });
        }
        landingpageAnimation();

        setTimeout(function() {
          var mySubmitController = Marionette.Object.extend({
            initialize: function() {
              this.listenTo(Backbone.Radio.channel('forms'), 'submit:response', this.actionSubmit);
            },

            actionSubmit: function(response) {
              if(response.data.fields_by_key['datei-id_1625247480798'].value.startsWith("http")) {
                window.location.replace(response.data.fields_by_key['datei-url_1625247490965'].value);
              } else {
                var link = response.data.fields_by_key['datei-url_1625247490965'].value;
                var a = document.createElement('A');
                a.href = link;
                a.download = link.substr(link.lastIndexOf('/') + 1);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                overlayCloseTriggerReload = true;
              }
            },
          });
          new mySubmitController();
        }, 500);

        var rellax = new Rellax('.rellax', {
          center: true,
          wrapper: null,
          round: true,
          vertical: true,
          horizontal: false
        });

        $('table.tablepress').wrap('<div class="tablepress-wrapper"></div>');

        $('a[href$=".mp4"]').fancybox();

        /* Remove Cookies */
        Cookies.remove('event');

        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        var eventer = window[eventMethod];
        var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

        // Listen to message from child window
        eventer(messageEvent,function(e) {
          if(e.data.action == 'contact-request') {
            var data = e.data.data.articles[0];

            var action;
            var lang = $('html').attr('lang');
            if(lang == 'de-DE') {
              action = '/konfigurator-formular/';
            } else if(lang == 'en-US') {
              action = '/us/configurator-form/';
            } else {
              action = '/en/configurator-form/';
            }
            var baseArticleNumber = data.baseArticleNumber;
            var variantCode = data.variantCode.trim().split('@')[0];
            if(variantCode == '') {
              variantCode = ' ';
            }
            var form = $('<form action="' + action + '" method="get">' +
              '<input type="hidden" name="baseArticleNumber" value="' + baseArticleNumber + '" />' +
              '<input type="hidden" name="variantCode" value="' + variantCode + '" />' +
              '<input type="hidden" name="longText" value="' + data.longText + '" />' +
              '<input type="hidden" name="itemId" value="' + data.itemId + '" />' +
              '<input type="hidden" name="featureText" value="' + data.featureText + '" />' +
              '</form>');
            $('body').append(form);
            $(form).submit();
          }
        }, false);
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        /* Variables */
        var htmlBody = $('html, body');

        /* Disable Scrolling */
        function disableScrolling() {
          if($('body').css('position') != 'fixed') {
            $('body').css('top', '-' + $(window).scrollTop() + 'px').css('position', 'fixed').css('width', '100%');
          }
        }
        function enableScrolling() {
          if($('body').css('position') == 'fixed') {
            var scrollTop = parseInt($('body').css('top').replace('-', '').replace('px', ''));
            $('body').css('top', '0').css('position', 'static').css('width', 'auto');
            $(window).scrollTop(scrollTop);
          }
        }

        /* Slider */
        var slider = $('.slider.main-slider');
        slider.slick({
          autoplay: false,
          prevArrow: '<button type="button" class="slick-prev"></button>',
          nextArrow: '<button type="button" class="slick-next"></button>',
          dots: true,
          draggable: false,
          fade: true,
          speed: 750
        });

        /* Scroll Down */
        var scrollDown = $('.scroll-down');
        scrollDown.click(function() {
          htmlBody.animate({ scrollTop: slider.height() }, 500);
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
